const ERRORS = {
    E_INVALID_EMAIL_OR_PASSWORD: 'E-mail ou senha inválidos.',
    E_EMAIL_ALREADY_EXISTS: 'Já existe um usuário cadastrado com esse e-mail.',
    E_INSTANCE_CONNECTED: 'Esse bot já possui uma instância conectada.',
    E_INSTANCE_NOT_AVAILABLE: 'Não há nenhum instância disponível no momento, tente novamente mais tarde.',
    E_NOT_POSSIBLE_DELETE_EVENT: 'Não foi possível deletar o evento'
};

export default ERRORS;